//app


//小程序
(function() {
    var url = JSON.stringify(document.location);
	var data = {};
	if(url.indexOf("token") != -1) {
		var searchURL = document.location.href;
		searchURL =searchURL.split("?")[1];
		console.log(searchURL)
		data.token = searchURL.split("&")[0].split("=")[1];
		data.randomKey = searchURL.split("&")[1].split("=")[1];
		data.userId = searchURL.split("&")[2].split("=")[1];
		console.log(data)
		localStorage.setItem('tokenInfo',btoa(JSON.stringify(data)));
	}
})();


// WEBPACK FOOTER //
// ./src/config/getAppUserInfo.js